export default class OrdineIngrediente {
    ingrediente: string;
    rimovibile: boolean;
    selected: boolean;

    constructor() {
        this.ingrediente = "";
        this.rimovibile = false;
        this.selected = false;
    }

    static convertFromFirestore(object: firebase.firestore.DocumentData): OrdineIngrediente {
        let ordineIngrediente: OrdineIngrediente = new OrdineIngrediente();
        ordineIngrediente.ingrediente = object.ingrediente;
        ordineIngrediente.rimovibile = object.rimovibile;
        ordineIngrediente.selected = object.selected;
        return ordineIngrediente;
    }

    static convertToFirestore(object: OrdineIngrediente): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.ingrediente = object.ingrediente;
        result.rimovibile = object.rimovibile;
        result.selected = object.selected;
        return result;
    }
}